import { Locale } from 'src/types'

export const hideTableColumn = (
  isMobile: boolean,
  label: string,
  locale: Locale['serviceContacts'],
): string => {
  const { contactName, phoneNumber } = locale.addServiceContacts

  return isMobile && ![contactName, phoneNumber].includes(label) ? 'hidden' : ''
}
